<template>
    <v-row>
        <v-col>
            <v-text-field v-model="value" :label="label" persistent-placeholder outlined dense hide-details class="rounded-0" />
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: ["value", "label"],
};
</script>

<style></style>
